import React from "react";
import Button from "../../design/Button";
import GModal from "../../design/components/GModal";

function WarnModal({
  heading,
  message,
  visible,
  closeModal,
  actionButtonTitle,
  handleAction,
  hideCancelButton,
  showLoader = false,
}) {
  return (
    <GModal
      modalStyle={{ width: "448px" }}
      closeModal={closeModal}
      heading={heading}
      visible={visible}
      bottomButtons={[
        <>
          {!hideCancelButton && (
            <Button
              variant="outlined"
              buttonText="Cancel"
              icon={{}}
              disabled={false}
              isLoading={false}
              hierarchy="white"
              onClick={closeModal}
            />
          )}
        </>,
        <Button
          variant="filled"
          buttonText={actionButtonTitle}
          icon={{}}
          isLoading={showLoader}
          hierarchy="red"
          disabled={false}
          onClick={handleAction}
        />,
      ]}
      body={<>{message}</>}
    />
  );
}

export default WarnModal;
